import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { InvoicingJobListService } from '../../../core/e-commerce/_services';

@Component({
	selector: 'kt-barcode',
	templateUrl: './barcode.component.html',
	styleUrls: ['./barcode.component.scss']
})
export class BarcodeComponent {

	constructor(
		public dialogRef: MatDialogRef<BarcodeComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: AlertData,
		private invoicingService: InvoicingJobListService) {
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

	public downloadBarCode() {
		this.invoicingService.downloadBarcode(this.data.orderId);
	}
}

export interface AlertData {
	title: string;
	barcodeNumber: string;
	resellerName: string;
	balance: number;
	orderId: number;
}
